// Display-facing values for the current admission cycle.
//
// This mirrors server/config/session.js and server/config/fees.js. The server
// is always the authority: it computes the fee that is actually charged and
// enforces the submission deadline. Everything here is presentation only, so a
// stale value shows wrong text but cannot cause a wrong charge or let a late
// application through.
//
// When you roll the session over, update this file AND the two server configs.

// Explicit +05:30 offset so the deadline does not shift with the viewer's
// timezone — a candidate in another timezone sees the same cutoff moment.
export const APPLICATIONS_CLOSE_AT = new Date('2026-08-27T17:00:00+05:30');

export const SESSION = {
  year: 2026,
  label: '2026-27',

  applications: {
    closesAt: APPLICATIONS_CLOSE_AT,
    closesAtLabel: '27-08-2026, 5:00 PM'
  },

  // Mirrors server/config/session.js — printed on the admit card header.
  institute: {
    university: 'BANARAS HINDU UNIVERSITY',
    name: 'Institute of Medical Sciences',
    faculty: 'Faculty of Ayurveda',
    logo: '/bhu-logo.png'
  },

  exam: {
    dateLabel: '13-09-2026',
    dayLabel: 'Sunday',
    time: '11:00 am to 1:00 pm',
    centre: 'New Lecture Theatre, IMS BHU',
    centreAddress: 'New Lecture Theatre, Institute of Medical Sciences, Banaras Hindu University, Varanasi, Uttar Pradesh - 221005'
  },

  admitCards: {
    availableFromLabel: '05-09-2026'
  },

  courses: {
    bpharm: {
      short: 'BPharm (Ay.) 2026',
      full: 'Bachelor of Pharmacy (Ayurveda) 2026',
      label: 'B.Pharm',
      durationLabel: '4 Years',
      seats: 37
    },
    mpharm: {
      short: 'MPharm (Ay.) 2026',
      full: 'Master of Pharmacy (Ayurveda) 2026',
      label: 'M.Pharm',
      durationLabel: '2 Years',
      seats: 15
    }
  }
};

// Categories a candidate may apply under, per the 2026 brochures.
export const CATEGORIES = ['General', 'OBC', 'EWS', 'SC', 'ST', 'PWD'];

// Fee table (INR). NOTE: OBC and EWS pay the STANDARD fee — only SC/ST/PWD are
// reduced. This differs from the 2025 cycle, where OBC sat in the lower bracket.
const STANDARD_FEE_CATEGORIES = ['General', 'OBC', 'EWS'];

const FEES = {
  bpharm: { standard: 1200, reduced: 900 },
  mpharm: { standard: 1500, reduced: 1000 }
};

/** Fee shown to the applicant. The server recomputes this authoritatively. */
export function getFee(courseType, category) {
  const table = FEES[courseType];
  if (!table) return null;
  return STANDARD_FEE_CATEGORIES.includes(category) ? table.standard : table.reduced;
}

/** True while new applications may still be submitted. */
export function applicationsOpen(now = new Date()) {
  return now < APPLICATIONS_CLOSE_AT;
}

/** Course display info, or null for an unknown course type. */
export function courseInfo(courseType) {
  return SESSION.courses[courseType] || null;
}

export default SESSION;
